import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=d141621c&scoped=true&"
import script from "./IconArrow.vue?vue&type=script&lang=js&"
export * from "./IconArrow.vue?vue&type=script&lang=js&"
import style0 from "./IconArrow.vue?vue&type=style&index=0&id=d141621c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d141621c",
  null
  
)

export default component.exports